// =============================================================================
// actions/incidentActions.js
//
// FIX5 — fetchIncidents() sends every filter dimension plus a fixed, generous
// `maxRows` safety cap to the server (see kpiRequests.apiFetchIncidents).
// There is no more page/pageSize: the server returns ALL rows matching the
// filters in one shot (up to maxRows), and the table paginates that result
// in memory. The payload is still a PagedResultDto ({ items, totalCount }) —
// totalCount is the TRUE match count (even if items was truncated by
// maxRows), which the UI uses to warn the operator when that happens.
// =============================================================================
import {
	INCIDENTS_FETCH_REQUEST, INCIDENTS_FETCH_SUCCESS, INCIDENTS_FETCH_FAILURE,
	INCIDENT_HISTORY_FETCH_REQUEST, INCIDENT_HISTORY_FETCH_SUCCESS, INCIDENT_HISTORY_FETCH_FAILURE,
	INCIDENT_SELECT, INCIDENT_FILTER_CHANGE, INCIDENT_FILTER_RESET,
} from '../constants/kpiConstants';

import { apiFetchIncidents, apiFetchIncidentHistory } from '../requests/kpiRequests';

// Safety ceiling sent on every request — matches the backend default. Not
// user-configurable; just protects the browser from an unbounded response
// if the operator applies very broad filters (e.g. Tech=all, KPI=all).
const MAX_ROWS = 20000;

// --- Incident list ------------------------------------------------------
// Reads the CURRENT filters straight from the store, so it behaves the same
// whether triggered by the Apply button or anything else that calls load().
export function fetchIncidents() {
	return async function (dispatch, getState) {
		dispatch({ type: INCIDENTS_FETCH_REQUEST });
		try {
			const state = getState().incidents;
			const f = state.filters;
			const params = {
				status:         f.status || 'Open',
				tech:           f.tech !== 'all' ? f.tech : undefined,
				kpiName:        f.kpiName !== 'all' ? f.kpiName : undefined,
				vendor:         f.vendor !== 'all' ? f.vendor : undefined,
				severity:       f.severity !== 'all' ? f.severity : undefined,
				siteId:         f.siteId || undefined,
				cellId:         f.cellId || undefined,
				durationBucket: f.durationBucket !== 'all' ? f.durationBucket : undefined,
				maxRows:        MAX_ROWS,
			};
			const res = await apiFetchIncidents(params);
			dispatch({ type: INCIDENTS_FETCH_SUCCESS, payload: res.data });
		} catch (err) {
			const msg = (err.response && err.response.data && err.response.data.error) || err.message;
			dispatch({ type: INCIDENTS_FETCH_FAILURE, payload: msg });
		}
	};
}

// --- History of a single incident -------------------------------------------
export function fetchIncidentHistory(incidentId) {
	return async function (dispatch) {
		dispatch({ type: INCIDENT_HISTORY_FETCH_REQUEST });
		try {
			const res = await apiFetchIncidentHistory(incidentId);
			dispatch({ type: INCIDENT_HISTORY_FETCH_SUCCESS, payload: res.data });
		} catch (err) {
			const msg = (err.response && err.response.data && err.response.data.error) || err.message;
			dispatch({ type: INCIDENT_HISTORY_FETCH_FAILURE, payload: msg });
		}
	};
}

// --- Selection, filters -----------------------------------------------------
export function selectIncident(incident) {
	return { type: INCIDENT_SELECT, payload: incident };
}

export function changeFilter(filter) {
	return { type: INCIDENT_FILTER_CHANGE, payload: filter };
}

export function resetFilters() {
	return { type: INCIDENT_FILTER_RESET };
}